// extracted by mini-css-extract-plugin
var _1 = "Mask-moduleMask__Puct6";
export { _1 as "Mask" }
